export const ROLE_LABEL = { welder: "Welder", tester: "Tester", both: "Welder + Tester" };
